import {Component, ElementRef, ViewChild, Renderer2} from "@angular/core";
import {IonicPage, NavController, NavParams} from "ionic-angular";
import {ApiServiceProvider} from "../../providers/api.service";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn
} from "@angular/forms";
import {GlobalServiceProvider} from "../../providers/global.service";
import {MajimeHeaderbarComponent} from "../../components/headerbar/majime-headerbar";

// import {Observable} from "rxjs/Observable";

/**
 * Generated class for the HandmadeQueriesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

function typeValidator(schema: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    debugger;
    return null;
  };
}

@IonicPage()
@Component({
  selector: "page-handmade-queries",
  templateUrl: "handmade-queries.html"
})
export class HandmadeQueriesPage {
  @ViewChild("formPanel") formPanel: ElementRef;
  public routeForm: FormGroup;
  public routes: any;
  public schemaKeys = [];
  public selectedRoute: any;

  public hasResult = false;
  public response: any;

  public user = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public api: ApiServiceProvider,
    private fb: FormBuilder,
    public global: GlobalServiceProvider
  ) {
    this.selectedRoute = {method: null};
    this.routeForm = this.fb.group({});
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad HandmadeQueriesPage");

    this.api.get("/availableRoutesJSON").then(routes => {
      this.routes = routes;
      console.log("got my routes");
    });
  }

  buildForm(route) {
    this.selectedRoute = route;
    console.log(route);
    let formObj: Array<FormControl> = [];
    if (route.settings && route.settings.schema) {
      this.schemaKeys = Object.keys(route.schema);
      for (let i = 0; i < this.schemaKeys.length; i++) {
        formObj[this.schemaKeys[i]] = new FormControl();
        // formObj.setValidators(typeValidator(route.settings.schema[this.schemaKeys[i]]))
      }
    } else {
      if (route.method === "get") {
        this.api
          .get(route.path)
          .then(result => {
            console.log(result);
            this.response = JSON.stringify(result, null, 2);
          })
          .catch(error => {
            console.log(error);
            this.response = error;
          });
      }
    }

    this.routeForm = this.fb.group(formObj);
  }

  parseValues(values, schema) {
    console.log(schema);
    let keys = Object.keys(schema);
    for (let i = 0; i < keys.length; i++) {
      let k = keys[i];
      console.log(k, ": ", schema[k]);
      if (schema[k].type) {
        try {
          switch (typeof schema[k].type.toLowerCase()) {
            //schema[k].type are not typescript types
            //but I have to use lowercase literals like "object"
            //because typescript complains
            case "object":
              console.log();
              if (values[k] !== null) values[k] = JSON.parse(values[k]);
              break;
            case "number":
              if (values[k] !== null) values[k] = parseFloat(values[k]);
              break;
          }
        } catch (error) {
          console.log("error parsing schema[", k, "] type ", schema[k].type);
          console.error(error);
        }
      } else if (Array.isArray(schema[k])) {
        try {
          if (values[k] !== null) values[k] = JSON.parse(values[k]);
        } catch (error) {
          console.log("error parsing schema[", k, "] as Array ", schema[k].type);
          console.error(error);
        }
      }
    }
  }

  submit() {
    let values = this.routeForm.value;
    console.log(values);
    this.parseValues(values, this.selectedRoute.schema);
    let indexValue = "";
    if (this.selectedRoute.method == "get") {
      //get the index
      if (this.selectedRoute.settings) {
        if (this.selectedRoute.settings.index) {
          indexValue = values[this.selectedRoute.settings.index];
        }
        this.api
          .get(this.selectedRoute.settings.route + "/" + indexValue)
          .then(result => {
            this.response = JSON.stringify(result, null, "\t");
          })
          .catch(error => {
            this.response = JSON.stringify(error, null, "\t");
          });
      }
    } else if (this.selectedRoute.method === "post") {
      if (this.selectedRoute.settings) {
        this.api
          .post(this.selectedRoute.settings.route, values)
          .then(response => {
            this.response = JSON.stringify(response, null, "\t");
          })
          .catch(error => {
            console.log(error);
            this.response = JSON.stringify(error, null, "\t");
          });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/handmade-queries/handmade-queries.ts